
import Vue from "vue";
import rules from "@/services/helpers/validation-rules";
import API from "@/api/API";
import store from "@/store";

export default Vue.extend({
  name: "Create",

  data: () => ({
    rules,
    model: {},
    errorMessages: {} as { [value: string]: Array<string> },
    currencies: [] as Array<SelectComponentInterface>
  }),

  async beforeRouteEnter(to, from, next) {
    try {
      const currencies = await API.currency().getList();

      next(vm => {
        vm.currencies = currencies.items;
      });
    } catch (e) {
      await store.dispatch("alert/showError", e.message);
    }
  },

  methods: {
    async submit(): Promise<void> {
      try {
        if ((this.$refs.form as Vue).validate()) {
          await this.$API.exchangeRates().create({
            currencies: this.currencies,
            date: this.$moment().format("YYYY-MM-DD")
          });
          await this.$router.push("/exchange-rates");
          await this.$store.dispatch(
            "alert/showSuccess",
            this.$t("global_alert.successful_create")
          );
        }
      } catch (e) {
        if (e.hasOwnProperty("errors")) {
          this.errorMessages = e.errors;

          setTimeout(() => {
            this.errorMessages = {};
          }, 2000);
        }
        await this.$store.dispatch("alert/showError", e.message);
      }
    }
  }
});
